module.exports = __webpack_public_path__ + "src-notif-hotels.png?2d498975fdec63cabfdbbfaeb02edcc7";